import React, { useState } from 'react';
import { Form, Button, InputNumber } from 'antd';

const InputNumberField = ({ name, label, rules, handleOnChange, isDisabled = false, maxAmount, minAmount = 0, defaultValue}) => {
  
  // console.log({name})
  // console.log({defaultValue})
  // console.log({maxAmount})
  // console.log({minAmount})


  return (
    <Form.Item label={label} name={name} rules={rules}>
      <InputNumber defaultValue={defaultValue} disabled={isDisabled} onChange={handleOnChange} min={minAmount} max={maxAmount}/>
    </Form.Item>
  );
};

export default InputNumberField;
